module.exports = __webpack_public_path__ + "img/gain-item3.35762a70.png";